import React from 'react';
import Button from '~/components/button';
import GeniusModal from '~/components/genius_modal';
const ComparisonConfirmation = (props) => {
    const { isVisible, onHide, handleClick, comparisonNames, message, buttonText, } = props;
    const projectNames = comparisonNames.join(', ');
    return (React.createElement(GeniusModal, { isModalShowing: isVisible, alertForm: true, onHide: onHide, bodyContent: React.createElement(React.Fragment, null,
            React.createElement("label", { className: 'modal-input-label', htmlFor: 'Location' }, message),
            React.createElement("div", { className: 'modal-project-name-wrapper' },
                React.createElement("div", { className: 'project-name', title: projectNames }, projectNames))), footerContent: React.createElement("div", { className: 'action-button-wrapper' },
            React.createElement(Button, { className: 'modal-action-btn', primary: true, onClick: () => { onHide(); handleClick(); } }, buttonText)) }));
};
export default ComparisonConfirmation;
